<script>
  import { layoutMethods, prpMethods } from "@/state/helpers";
  import ImageUploader from "@/components/ImageUploader";
  import Swal from 'sweetalert2';
  import { getModuleAccess } from '@/router/helper.js'

  /**
   * PRP item List component
   */
  export default {
    page: {
      title: "PRP Item Form"
    },
    components: {
      ImageUploader,
    },
    computed: {
    },
    data() {
      return {
        title: "PRP Item Form",
        folder: "prp-images",
        prp_item_id : 0,
        form:{
          status          : true,
          item_prize      : null,
          imageSrc        : null,
          category        : null,
          prp_amount      : null,
          type            : null,
          receive_amount : null,
        },
        formExitChecker:{
          status          : true,
          item_prize      : null,
          imageSrc        : null,
          category        : null,
          prp_amount      : null,
          type            : null,
          receive_amount : null,
        },
        formImage: {
          filename: null,
          type: null,
          base64: null,
        },
        submitted : false,
        categoryOption:[{"value": null,"text":"Select Category", disabled:true}],
        typeOption:[
          {"value": null,"text":"Select Type", disabled:true},
          {"value": "coins","text":"Blvck Coins"},
          {"value": "logistics","text":"Logistics"},
          {"value": "subscription","text":"Subscription"},
          {"value": "wheel-weekly","text":"Wheel Weekly"},
          {"value": "eload","text":"eLoad"},
        ],
        recently_uploaded :null,
        prpItemsModule: {
          access: {
            create: true,
            read: true,
            update: true,
            delete: true
          }
        }
      };
    },
    methods: {
      ...layoutMethods,
      ...prpMethods,
      cancelRouting(){
          this.$router.push(
            this.$route.query.redirectFrom || {
              name: "PRP Items"
            }
          );
      },
      async save(){
        if (this.prp_item_id > 0) {
          this.updatePrpItem();
        } else {
          this.createPrpItem();
        }
      },
      getValidationState({ dirty, validated, valid = null }) {
        return dirty || validated ? valid : null;
      },
      clearLogo() {
        this.formImage = {
          filename: null,
          type: null,
          base64: null,
        };
        if(this.recently_uploaded != null){ // this will handle the uploaded image but not yet  inserted in db
          // this.actionPRP({
          //     action: "delete-recently-uploaded",
          //     body: {"recently_uploaded":this.recently_uploaded}
          // })
          // .then((res) => {
          //     console.log(res)
          //     this.recently_uploaded = null;
          // })
        }
      },
      compareStr(data, arr_similar){// case insensitive string comparison
        for(var i = 0; i < arr_similar.length; i++){
            var areEqual = data.toUpperCase() === arr_similar[i].toUpperCase();
              if(areEqual){
                return areEqual;
              }
          }
          return false;
      },
      createPrpItem() {
        var templateObj = {...this.form};
        console.log(":: form image ::",JSON.stringify(this.formImage))
        if (this.formImage.base64) {
          if(this.compareStr(this.formImage.type,["jpg","jpeg","png","svg"]) === false){//"jpeg","png","svg","jpg",
            this.clearLogo();
            Swal.fire("Invalid Image!", `Image is required`, "error");
            return;
          }
          var formImage = { ...this.formImage };
          formImage.folder = this.folder;

          this.uploadLogo(formImage)
            .then((imageKey) => {
              templateObj = {
                ...templateObj,
                formImageSrc: `${this.folder}/${imageKey}`,
              };
              this.recently_uploaded = `${this.folder}/${imageKey}`;
              this.create(templateObj);
            })
            .catch((err) => {
              Swal.fire("Upload Failed!", `${err}`, "error");
            });
        } else {
          if(this.recently_uploaded != null){
            templateObj["formImageSrc"] = this.recently_uploaded
          }
          this.create(templateObj);
        }
      },
      create(templateObj) {
        this.actionPRP({
            action: "create-item",
            body: templateObj
        })
        .then((res) => {
            console.log(res)
            Swal.fire(
              (this.prp_item_id > 0 ?"Updated":"Created")+" Successful!",
              `${templateObj.item_prize} has been ${(this.prp_item_id > 0 ?"updated":"created")}.`,
              "success"
            );
            this.formExitChecker = {...this.form}
            this.clearLogo();
            this.cancelRouting();
        }).catch((e)=>{
          console.log("error while getting details",e);
          Swal.fire(
            "Create Failed!",
            e ? e : `${templateObj.item_prize} was not created.`,
            "error"
          );
          this.clearLogo();
        });
      },
      async getCategoryall(){
        await this.actionPRP({
            action: "all-category",
            body: {}
        })
        .then((res) => {
          for(let r of res["message"]){
            this.categoryOption.push({"value": r["id"],"text":r["name"]});
          }
        }).catch((e)=>{
          console.log("error while getting details",e);
        });
      },
      async getItemDetails(){
        await this.actionPRP({
            action: "item-details",
            body: {"prp_item_id":this.prp_item_id}
        })
        .then((res) => {
          this.form.status                = res["message"]["status"] 
          this.form.item_prize            = res["message"]["reward"]
          this.form.imageSrc              = res["message"]["imageSrc"]
          this.form.category              = res["message"]["prp_category_id"]
          this.form.prp_amount            = res["message"]["amount"]
          this.form.type                  = res["message"]["type"]
          this.form.receive_amount                  = res["message"]["receive_amount"]
          this.form.formImageSrc          = res["message"]["image"]
          this.formExitChecker            = {...this.form}
        }).catch((e)=>{
          console.log("error while getting details",e);
        });
      },
      updatePrpItem() {
        var templateObj = { ...this.form };
        console.log(":: form image ::",JSON.stringify(this.formImage))

        if (this.formImage.base64) {
          if(this.compareStr(this.formImage.type,["jpg","jpeg","png","svg"]) === false){//"jpeg","png","svg","jpg",
            this.clearLogo();
            Swal.fire("Invalid Image!", `Image is required`, "error");
            return;
          }
          var formImage = { ...this.formImage };
          formImage.folder = this.folder;

          this.uploadLogo(formImage)
            .then((imageKey) => {
              templateObj = {
                ...templateObj,
                formImageSrc: `${this.folder}/${imageKey}`,
              };
              this.recently_uploaded = `${this.folder}/${imageKey}`;
              // console.log("upload logo",imageKey);
              this.update(templateObj);
            })
            .catch((err) => {
              Swal.fire("Upload Failed!", `${err}`, "error");
            });
        } else {
          if(this.recently_uploaded != null){
            templateObj["formImageSrc"] = this.recently_uploaded
          }
          this.update(templateObj);
        }
      },
      update(templateObj) {
        this.actionPRP({
            action: "item-update",
            body: {...templateObj,"prp_item_id":this.prp_item_id}
        })
        .then((res) => {
            console.log(res)
            Swal.fire(
              (this.prp_item_id > 0 ?"Updated":"Created")+" Successful!",
              `${templateObj.item_prize} has been ${(this.prp_item_id > 0 ?"updated":"created")}.`,
              "success"
            );
            this.formExitChecker = {...this.form}
            this.clearLogo();
            this.cancelRouting();
        }).catch((e)=>{
          console.log("error while getting details",e);
          Swal.fire(
            "Update Failed!",
            e ? e : `${templateObj.item_prize} was not updated.`,
            "error"
          );
          this.clearLogo();
        });
      },
      leaveform(next){
          if(JSON.stringify(this.form) == JSON.stringify(this.formExitChecker) && this.formImage["filename"] == null){
            next();
            return;
          }
          Swal.fire({
              title: 'Are you sure?',
              text: "you want to leave this page?",
              icon: 'question',
              showCancelButton: true,
              confirmButtonColor: '##804997',
              cancelButtonColor: '#d33',
              confirmButtonText: 'Yes',
              cancelButtonText: 'No'
          }).then((result) => {
              if (result.isConfirmed) {
                  next();
              }else{
                  return;
              }
          })
      },
    },
    async mounted(){
      this.getCategoryall();
      this.changeTitle({title: 'PRP Item Form'});
      this.changeBreadCrumb({
        breadCrumbs: [
          { text: 'Peddlr', to: { name: 'Home'} },
          { text: 'PRP Category', to: { name: 'PRP Category'} },
          { text: 'PRP Item Form', to: { name: 'PRP Item Form'} }
        ]
      });
      this.prp_item_id = this.$route.params.id;
      if(this.prp_item_id > 0){
        // alert("hey eedited");
        this.getItemDetails();
      }

      // get the module access for checking if user has create, read, update, and/or delete access
      await getModuleAccess('Utilities', 'PRP', 'PRP Items')
        .then((access) => this.prpItemsModule.access = access);
    },
    beforeRouteLeave(to, from, next) {
        if(JSON.stringify(this.form) != JSON.stringify(this.formExitChecker) || this.formImage["filename"] != null){
          this.leaveform(next);
        }else{
          next();
        }
    }
  }
    
</script>

<template>
  <div><!-- outer div-->
    <ValidationObserver v-slot="{ handleSubmit, reset }">
      <b-form ref="form" @submit.prevent="handleSubmit(save)" @reset.prevent="reset">
        <div class="row">
          <div class="col-lg-2 me-4">
            <image-uploader
              class="img-fluid"
              v-model="formImage"
              :isRequired="true"
              :imageSrc="form.imageSrc"
            />
          </div>

          <div class="col-lg-6">
            <div class="card">
              <div class="card-body">
                <div>
                  <b-row>
                    <label v-if="prp_item_id <= 0 && !prpItemsModule.access.create" class="form-label medium fw-bold text-danger mb-3">Note: Your access is limited. You cannot create a PRP Item.</label>
                    <label v-else-if="prp_item_id > 0 && !prpItemsModule.access.update" class="form-label medium fw-bold text-danger mb-3">Note: Your access is limited. You cannot update a PRP Item.</label>    
                    <b-col sm="12" class="mb-3">
                      <div class="form-check form-switch">
                        <label class="form-check-label" for="flexSwitchCheckDefault">Active</label>
                        <input
                          class="form-check-input"
                          v-model="form.status"
                          type="checkbox"
                          id="flexSwitchCheckDefault"
                        />
                      </div>
                    </b-col><!--end of status-->
                    <b-col sm="12" class="mb-3">
                      <label class="form-label small fw-bold"
                        >Item Prize<span style="color: red">*</span></label
                      >
                      <validation-provider
                        name="item prize"
                        rules="required"
                        v-slot="validationContext"
                      >
                        <b-form-input
                          :state="getValidationState(validationContext)"
                          type="text"
                          class="form-control"
                          v-model="form.item_prize"
                          placeholder="Enter Product Name"
                        />
                        <b-form-invalid-feedback>
                          {{ validationContext.errors[0] }}
                        </b-form-invalid-feedback>
                      </validation-provider>
                    </b-col><!--item prize-->
                    <b-col sm="12" class="mb-3">
                      <label class="form-label small fw-bold"
                        >Category<span style="color: red">*</span></label
                      >
                      <validation-provider
                        name="category"
                        rules="required"
                        v-slot="validationContext"
                      >
                        <b-form-select
                          class="form-control" 
                          placeholder="Select Category"
                          v-model="form.category" 
                          :options="categoryOption" 
                          :state="getValidationState(validationContext)"
                        />
                        <b-form-invalid-feedback>
                          {{ validationContext.errors[0] }}
                        </b-form-invalid-feedback>
                      </validation-provider>
                    </b-col><!--item category-->
                    <b-col sm="12" class="mb-3">
                      <label class="form-label small fw-bold"
                        >PRP Amount<span style="color: red">*</span></label
                      >
                      <validation-provider
                        name="prp amount"
                        rules="required"
                        v-slot="validationContext"
                      >
                        <b-form-input
                          :state="getValidationState(validationContext)"
                          type="number"
                          class="form-control"
                          v-model="form.prp_amount"
                          placeholder="Enter PRP Amount"
                        />
                        <b-form-invalid-feedback>
                          {{ validationContext.errors[0] }}
                        </b-form-invalid-feedback>
                      </validation-provider>
                    </b-col><!--prp amount-->
                    <b-col sm="12" class="mb-3">
                      <label class="form-label small fw-bold"
                        >Receive Amount<span style="color: red">*</span></label
                      >
                      <validation-provider
                        name="prp amount"
                        rules="required"
                        v-slot="validationContext"
                      >
                        <b-form-input
                          :state="getValidationState(validationContext)"
                          type="number"
                          class="form-control"
                          v-model="form.receive_amount"
                          placeholder="Enter the Amount"
                        />
                        <b-form-invalid-feedback>
                          {{ validationContext.errors[0] }}
                        </b-form-invalid-feedback>
                      </validation-provider>
                    </b-col><!--prp amount-->
                    <b-col sm="12" class="mb-3">
                      <label class="form-label small fw-bold"
                        >Type<span style="color: red">*</span></label
                      >
                      <validation-provider
                        name="type"
                        rules="required"
                        v-slot="validationContext"
                      >
                        <b-form-select
                          class="form-control" 
                          placeholder="Select Type"
                          v-model="form.type" 
                          :options="typeOption" 
                          :state="getValidationState(validationContext)"
                        />
                        <b-form-invalid-feedback>
                          {{ validationContext.errors[0] }}
                        </b-form-invalid-feedback>
                      </validation-provider>
                    </b-col><!--item category-->
                  </b-row>
                  <b-row class="mb-3">
                    <b-col>
                      <b-btn :disabled="prp_item_id <= 0 ? !prpItemsModule.access.create : !prpItemsModule.access.update" class="w-100" type="submit" variant="primary">Save</b-btn>
                    </b-col>
                    <b-col>
                      <b-btn class="w-100 btn btn-light" @click="cancelRouting">Cancel</b-btn>
                    </b-col>
                  </b-row>
                  
                </div>
              </div>
            </div>
          </div>
        </div>
      </b-form>
    </ValidationObserver>
  </div> <!-- end of outer div-->
</template>